enum SearchType {
    Bill = 'Bill',
    City = 'City',
    Company = 'Company',
    Customer = 'Customer',
    EnterpriseProfile = 'EnterpriseProfile',
    Locations = 'Locations',
    Navigation = 'Navigation',
    ProductServiceOrder = 'ProductServiceOrder',
    Reservation = 'Reservation',
    ReservationGroup = 'ReservationGroup',
    Resource = 'Resource',
    ResourceBlock = 'ResourceBlock',
    TravelAgency = 'TravelAgency',
}

export default SearchType;
